import { render, staticRenderFns } from "./ChannelSettings.vue?vue&type=template&id=209b28db&scoped=true&"
import script from "./ChannelSettings.vue?vue&type=script&lang=js&"
export * from "./ChannelSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSettings.vue?vue&type=style&index=0&id=209b28db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b28db",
  null
  
)

export default component.exports